import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IRole } from '../../models/role.model';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  currentRole: BehaviorSubject<IRole | undefined> = new BehaviorSubject<
    IRole | undefined
  >(undefined);

  private agency$ = new BehaviorSubject<Record<string, unknown>>({});
  selectedAgency$ = this.agency$.asObservable();

  private agenciesList$ = new BehaviorSubject<Record<string, unknown>[]>([]);

  agencies$ = this.agenciesList$.asObservable();

  setAgency(agency: Record<string, unknown>) {
    this.agency$.next(agency);
  }

  setAgencies(agencies: Record<string, unknown>[]) {
    this.agenciesList$.next(agencies);
  }
}
